/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-mixed-operators */
import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import { Link, useParams, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { GET, PATCH, POST } from "../../../services/AxiosService";
import Swal from "sweetalert2";
import Select from "react-select";

const FormPengguna = () => {
  const { id, flag } = useParams();
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    hp_no: "",
    email: "",
    name: "",
    password: "",
    password_confirmation: "",
    userRole: [{ role_id: "" }],
  });
  console.log("formData", formData.email);
  const [role, setRole] = useState([]);
  const [site, setSite] = useState([]);
  const [siteSelectShow, setSiteSelectShow] = useState([false]);
  const [addButtonShow, setAddButtonShow] = useState(false);
  const [element, setElement] = useState([0]);
  const navigate = useNavigate();
  const [passwordError, setPasswordError] = useState("");

  // Daftar role_id yang boleh pakai PIN 6 digit
  const PIN_ROLE_IDS = [
    "833928d4-f76a-41c7-b9c6-df51343d249e",
    "d1f3a2a6-c398-47eb-b45f-2bd2b4587c1e",
    "9ca5e34b-594d-4b1f-a55c-917572308153",
  ];

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+}{|":?><`]).{8,20}$/;

  const isCreate = !id; // true kalau tambah, false kalau edit

  const validatePassword = (password, userRoles) => {
    // password kosong => valid hanya kalau edit (tidak wajib mengganti password saat edit)
    if (!password) return !isCreate;

    const roleIds = userRoles?.map((r) => r.role_id) || [];
    const hasPinRole = roleIds.some((rid) => PIN_ROLE_IDS.includes(rid));

    if (hasPinRole) {
      // PIN mode: harus 6 digit
      return /^\d{6}$/.test(password);
    }

    // Complex password mode
    return passwordRegex.test(password);
  };




  const fetchData = async () => {
    const res = await GET(`user/web/${id}`);
    console.log("email", res.data.email);
    // setFormData(res?.data);
    setFormData({
      hp_no: res?.data?.hp_no,
      email: res?.data?.email,
      name: res?.data?.name,
      password: res?.data?.password, // Directly use the object { id, name }
      password_confirmation: res?.data?.password_confirmation,
      userRole: res?.data?.userRole,
    });
    setSiteSelectShow(res?.data.userRole.map((x) => x.role.site === 1));
    setElement(res?.data.userRole.map((x, idx) => idx));
    if (flag !== "detail") {
      setAddButtonShow(true);
    }
  };

  const fetchDataRole = async () => {
    const res = await GET(`role`);
    setRole(res?.data.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0)));
  };

  const fetchDataSite = async () => {
    const res = await GET(`site`);
    setSite(res?.data.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0)));
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

    // Khusus hp_no
    if (name === "hp_no") value = value.replace(/\D/g, "");

    // Khusus password untuk PIN role: hanya terima angka
    const userRoles = formData.userRole || [];
    const roleIds = userRoles.map((r) => r.role_id);
    const hasPinRole = roleIds.some((id) => PIN_ROLE_IDS.includes(id));
    
    if (name === "password" && hasPinRole) {
      value = value.replace(/\D/g, ""); // Hanya angka untuk PIN
    }
    
    if (name === "password_confirmation" && hasPinRole) {
      value = value.replace(/\D/g, ""); // Hanya angka untuk PIN
    }

    const updatedFormData = {
      ...formData,
      [name]: value,
    };

    setFormData(updatedFormData);

    // Password validation
    const password = name === "password" ? value : updatedFormData.password;
    const passwordConfirmation =
      name === "password_confirmation" ? value : updatedFormData.password_confirmation;

    const updatedUserRoles = updatedFormData.userRole || [];

    let passwordValid = true;
    let passwordConfirmValid = true;

    // Validasi password
    if (password) {
      passwordValid = validatePassword(password, updatedUserRoles);
      passwordConfirmValid = password === passwordConfirmation;

      if (!passwordValid) {
        const updatedRoleIds = updatedUserRoles.map((r) => r.role_id);
        if (updatedRoleIds.some((id) => PIN_ROLE_IDS.includes(id))) {
          setPasswordError("Password harus berupa 6 digit angka.");
        } else {
          setPasswordError(
            "Password harus 8-20 karakter dan mengandung huruf besar, huruf kecil, angka, serta karakter khusus."
          );
        }
      } else if (!passwordConfirmValid && passwordConfirmation) {
        setPasswordError("Konfirmasi password tidak cocok.");
      } else {
        setPasswordError("");
      }
    } else {
      // Password kosong
      if (!isCreate) {
        // Mode edit, password boleh kosong
        setPasswordError("");
        passwordValid = true;
        passwordConfirmValid = true;
      } else {
        // Mode create, password wajib
        setPasswordError("Password wajib diisi.");
        passwordValid = false;
      }
    }

    // Validasi group dan site
    const hasGroup = updatedFormData.userRole.length > 0;
    const allSitesSelected = updatedFormData.userRole.every((roleObj) => {
      const roleItem = role.find((r) => r.id === roleObj.role_id);
      if (!roleItem) return false;
      if (roleItem.site === 1)
        return roleObj.userRoleSites && roleObj.userRoleSites.length > 0;
      return true;
    });

    // Form validation umum
    const formIsValid =
      updatedFormData.name.length >= 4 &&
      updatedFormData.hp_no.length >= 8 &&
      passwordValid &&
      passwordConfirmValid &&
      hasGroup &&
      allSitesSelected;

    setValidated(formIsValid);
  };



  // const handleRoleChange = (e, idx) => {
  //   const { name, value } = e.target;
  //   const current = formData.userRole.map((x, index) => {
  //     if (idx === index) {
  //       x.role_id = value;
  //     }
  //     return x;
  //   });
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: current,
  //   }));

  //   const needSite = role.filter(x => x.id === value)[0]?.site === 1;
  //   const temp = siteSelectShow.map((x, index) => {
  //     return idx === index ? needSite : x;
  //   });
  //   setSiteSelectShow(temp);
  //   setAddButtonShow(!needSite);

  //   setValidated(!needSite);
  // };

  // const handleSiteChange = (e, idx) => {
  //   const { options } = e.target;
  //   const value = [];
  //   for (let i = 0, l = options.length; i < l; i++) {
  //     if (options[i].selected) {
  //       value.push(options[i].value);
  //     }
  //   }
  //   const current = formData.userRole.map((x, index) => {
  //     if (idx === index) {
  //       x.userRoleSites = value.map(r => {
  //         return { site_id: r };
  //       });
  //     }
  //     return x;
  //   });
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     'userRole': current,
  //   }));

  //   const form = e.currentTarget.form;
  //   const isValid = form.checkValidity();

  //   setValidated(isValid);

  //   if (isValid) {
  //     form.classList.remove("was-validated");
  //   } else {
  //     form.classList.add("was-validated");
  //   }

  //   setAddButtonShow(value.length > 0);
  // };

  // const handleSelectChange = (selectedOptions, name) => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: selectedOptions.map(option => option.value),
  //   }));
  // };
  const handleSelectChange = (selectedOptions, name) => {
    if (!selectedOptions || selectedOptions.length === 0) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: [],
      }));
      setSiteSelectShow([]);
      setValidated(false);
      return;
    }

    const newRoles = selectedOptions.map((option) => {
      const selectedRole = role.find((x) => x.id === option.value);
      return {
        role_id: option.value,
        userRoleSites: selectedRole && selectedRole.site === 1 ? [] : null,
      };
    });

    const newSiteSelectShow = selectedOptions.map((option) => {
      const selectedRole = role.find((x) => x.id === option.value);
      return selectedRole && selectedRole.site === 1;
    });

    const hasPinRole = newRoles.some((r) => PIN_ROLE_IDS.includes(r.role_id));
    const prevHasPinRole = formData.userRole?.some((r) =>
      PIN_ROLE_IDS.includes(r.role_id)
    );

    // cek apakah status PIN berubah
    const shouldResetPassword = hasPinRole !== prevHasPinRole;

    let newPassword = formData.password;
    let newPasswordConfirm = formData.password_confirmation;

    if (shouldResetPassword) {
      newPassword = "";
      newPasswordConfirm = "";
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: newRoles,
      password: newPassword,
      password_confirmation: newPasswordConfirm,
    }));

    setSiteSelectShow(newSiteSelectShow);

    if (newPassword) {
      const valid = validatePassword(newPassword, newRoles);
      if (!valid) {
        setPasswordError(
          hasPinRole
            ? "Password harus 6 digit angka"
            : "Password harus 8-20 karakter dan mengandung huruf besar, huruf kecil, angka, serta karakter khusus."
        );
        setValidated(false);
      } else if (newPassword !== newPasswordConfirm) {
        setPasswordError("Konfirmasi password tidak cocok.");
        setValidated(false);
      } else {
        setPasswordError("");
        setValidated(true);
      }
    } else {
      // ❌ Jangan munculkan error kalau password kosong DAN status role tidak berubah
      if (shouldResetPassword) {
        setPasswordError(
          hasPinRole
            ? "Password harus 6 digit angka"
            : "Password harus 8-20 karakter dan mengandung huruf besar, huruf kecil, angka, serta karakter khusus."
        );
        setValidated(false);
      } else {
        setPasswordError(""); // biarkan kosong, jangan munculkan error baru
        if (id) {
          setPasswordError("");
          setValidated(true);   // edit group doang, password kosong masih valid
        } else {
          setPasswordError("Password wajib diisi.");
          setValidated(false);  // create, password kosong = invalid
        }
      }
    }
  };






  const handleSiteChange = (e, idx) => {
    const { options } = e.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    const current = formData.userRole.map((x, index) => {
      if (idx === index) {
        x.userRoleSites = value.map((r) => {
          return { site_id: r };
        });
      }
      return x;
    });

    setFormData((prevData) => ({
      ...prevData,
      userRole: current,
    }));

    const form = e.currentTarget.form;
    const isValid = form.checkValidity();

    setValidated(isValid);

    if (isValid) {
      form.classList.remove("was-validated");
    } else {
      form.classList.add("was-validated");
    }

    setAddButtonShow(value.length > 0);
  };

  const handleRemoveClick = async (idx) => {
    setElement(element.filter((value, index) => index !== idx));
    setSiteSelectShow(siteSelectShow.filter((value, index) => index !== idx));
    const filtered = formData.userRole.filter((value, index) => index !== idx);
    setFormData((prevData) => ({
      ...prevData,
      userRole: filtered,
    }));
    let showButton = true;
    for (let i = 0; i < filtered.length; i++) {
      if (role.filter((x) => x.id === filtered[i].role_id)[0]?.site === 1) {
        if (!filtered[i].userRoleSites || filtered[i].userRoleSites.length === 0) {
          showButton = false;
        }
      }
    }
    setAddButtonShow(showButton);
    setValidated(showButton);
  };

  const handleAddClick = async () => {
    setElement([...element, element.length]);
    setSiteSelectShow([...siteSelectShow, false]);
    setAddButtonShow(false);
    setFormData((prevData) => ({
      ...prevData,
      userRole: [...formData.userRole, { role_id: "" }],
    }));

    setValidated(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: "Apakah Anda yakin akan menyimpan perubahan?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#5932EA",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya",
      cancelButtonText: "Batal",
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      let res;
      if (id) {
        delete formData.id;
        res = await PATCH(`user/${id}`, formData);
      } else {
        res = await POST(`user/web`, formData);
      }
      if (res) {
        Swal.fire({
          icon: "success",
          title: !id ? `Pengguna ${formData.name} berhasil ditambahkan.` : `Pengguna ${formData.name} berhasil diubah.`,
        }).then(() => {
          Swal.close();
          navigate(`/daftar-pengguna`);
        });
      }
    }
  };

  useEffect(() => {
    if (id) {
      fetchData();
    }
    fetchDataRole();
    fetchDataSite();
  }, []);

  return (
    <Fragment>
      <PageTitle activeMenu={`${id ? flag.charAt(0).toUpperCase() + flag.slice(1) : "Tambah"} Pengguna`} motherMenu="Daftar Pengguna" />
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            {flag === "detail" && (
              <div className="card-header">
                <div></div>
                <Link className="btn btn-primary mr-2" to={`/daftar-pengguna`}>
                  Kembali
                </Link>
              </div>
            )}
            <div className="card-body">
              <div className="form-validation mt-3">
                <form className="form-valide" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-xl-4">
                      <div className="form-group">
                        <label>
                          No HP<span className="text-danger">*</span>
                        </label>
                        <input 
                          disabled={id} 
                          type="text" 
                          className={`form-control ${
                            formData.hp_no && formData.hp_no.length < 8 
                              ? "is-invalid" 
                              : formData.hp_no && formData.hp_no.length >= 8 
                              ? "is-valid" 
                              : ""
                          }`}
                          value={formData.hp_no} 
                          name="hp_no" 
                          onChange={handleChange} 
                          maxLength="15"
                        />
                        {formData.hp_no && formData.hp_no.length < 8 && (
                          <div className="invalid-feedback" style={{ display: 'block' }}>
                            No HP harus diisi dengan angka minimal 8 digit.
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-4">
                      <div className="form-group">
                        <label>Email</label>
                        <input 
                          disabled={flag === "detail"} 
                          type="email" 
                          className="form-control" 
                          value={formData.email} 
                          name="email" 
                          onChange={handleChange} 
                        />
                      </div>
                    </div>
                    <div className="col-xl-4">
                      <div className="form-group">
                        <label>
                          Nama Lengkap<span className="text-danger">*</span>
                        </label>
                        <input 
                          disabled={flag === "detail"} 
                          type="text" 
                          className={`form-control ${
                            formData.name && formData.name.length < 4 
                              ? "is-invalid" 
                              : formData.name && formData.name.length >= 4 
                              ? "is-valid" 
                              : ""
                          }`}
                          value={formData.name} 
                          name="name" 
                          onChange={handleChange} 
                          maxLength="30"
                        />
                        {formData.name && formData.name.length < 4 && (
                          <div className="invalid-feedback" style={{ display: 'block' }}>
                            Nama Lengkap harus diisi minimal 4 karakter.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-5">
                      {role?.length > 0 && (
                        <div className="form-group">
                          <label>
                            Group<span className="text-danger">*</span>
                          </label>
                          <Select
                            isMulti
                            name="userRole"
                            options={role.map((item) => ({ value: item.id, label: item.name }))}
                            value={formData?.userRole
                              .filter((roleObj) => roleObj.role_id)
                              .map((roleObj) => ({
                                value: roleObj.role_id,
                                label: role.find((item) => item.id === roleObj.role_id)?.name,
                              }))}
                            onChange={(selectedOptions) => handleSelectChange(selectedOptions, "userRole")}
                            classNamePrefix="select"
                            isDisabled={flag === "detail"}
                          />

                        </div>
                      )}

                      {/* <label>Role<span className="text-danger">*</span></label>
                      {element.map(el => (
                        <div key={el} className='form-group' style={{ marginBottom: '71px' }}>
                          <select
                            disabled={flag === 'detail'}
                            className='form-control'
                            value={formData.userRole[el]?.role_id}
                            name="userRole"
                            onChange={(c) => {
                              handleRoleChange(c, el);
                            }}
                            required
                          >
                            <option value="">Pilih Role</option>
                            {Array.isArray(role) && role.map((r) => (
                              <option
                                key={r.id}
                                value={r.id}
                              >
                                {r.name}
                              </option>
                            ))}
                          </select>
                          <Form.Control.Feedback type="invalid">
                            Role harus dipilih.
                          </Form.Control.Feedback>
                        </div>
                      ))} */}
                    </div>
                    <div className="col-xl-5">
                      {siteSelectShow.map((r, idx) => (
                        <Fragment key={idx}>
                          {r ? (
                            <div className="form-group">
                              <select
                                multiple
                                disabled={flag === "detail"}
                                className="form-control"
                                value={formData.userRole[idx]?.userRoleSites?.map((x) => x.site_id)}
                                name="site_id"
                                onChange={(c) => {
                                  handleSiteChange(c, idx);
                                }}
                                required
                              >
                                {Array.isArray(site) &&
                                  site.map((r) => (
                                    <option key={r.id} value={r.id}>
                                      {r.name}
                                    </option>
                                  ))}
                              </select>
                              <Form.Control.Feedback type="invalid">Site harus dipilih.</Form.Control.Feedback>
                            </div>
                          ) : (
                            // <div className='form-group' style={{ height: '96px' }}></div>
                            ""
                          )}
                        </Fragment>
                      ))}
                     
                    </div>
                   
                  </div>
                  {flag !== "detail" && (
                    <div className="row">
                      <div className="col-xl-4">
                        <div className="form-group">
                          <label>
                            Password{id ? " Baru" : ""}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            disabled={flag === "detail"}
                            type="password"
                            className={`form-control ${
                              passwordError 
                                ? "is-invalid" 
                                : formData.password && !passwordError && validatePassword(formData.password, formData.userRole)
                                ? "is-valid" 
                                : ""
                            }`}
                            value={formData.password}
                            name="password"
                            onChange={handleChange}
                            maxLength={
                              formData.userRole.some((r) => PIN_ROLE_IDS.includes(r.role_id)) ? 6 : 20
                            }
                          />
                          {passwordError && (
                            <div className="invalid-feedback" style={{ display: 'block' }}>
                              {passwordError}
                            </div>
                          )}

                          {id && <label>Hanya diisi jika ingin mengubah password. Selain itu kosongkan.</label>}
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="form-group">
                          <label>
                            Konfirmasi Password{id ? " Baru" : ""} <span className="text-danger">*</span>
                          </label>
                          <input
                            type="password"
                            name="password_confirmation"
                            className={`form-control ${
                              formData.password_confirmation && formData.password_confirmation !== formData.password
                                ? "is-invalid"
                                : formData.password_confirmation && 
                                  formData.password_confirmation === formData.password && 
                                  formData.password &&
                                  validatePassword(formData.password, formData.userRole)
                                ? "is-valid"
                                : ""
                            }`}
                            value={formData.password_confirmation}
                            onChange={handleChange}
                            disabled={flag === "detail"}
                            maxLength={
                              formData.userRole.some((r) => PIN_ROLE_IDS.includes(r.role_id)) ? 6 : 20
                            }
                          />
                          {formData.password_confirmation && formData.password_confirmation !== formData.password && (
                            <div className="invalid-feedback" style={{ display: 'block' }}>
                              Konfirmasi password harus sama dengan password.
                            </div>
                          )}
                          {id && <label className="mt-2" style={{ fontSize: '12px', color: '#6c757d' }}>Hanya diisi jika ingin mengubah password. Selain itu kosongkan.</label>}
                        </div>
                      </div>
                    </div>
                  )}



                  {/* {addButtonShow && (
                    <div className="row">
                      <div className="col-xl-10"></div>
                      <div className="col-xl-2">
                        <div className='form-group'>
                          <Link className="btn btn-info shadow btn-xs sharp" onClick={handleAddClick}>
                            <i className="fa fa-plus"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  )} */}

                  {flag !== "detail" && (
                    <div className="form-group mb-3 d-flex">
                      <div className="col-xl-6">
                        <Link className="btn btn-light w-100" to={`/daftar-pengguna`}>
                          Batal
                        </Link>
                      </div>
                      <div className="col-xl-6">
                        <button type="submit" className="btn btn-primary w-100" disabled={!validated}>
                          Simpan Perubahan
                        </button>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default FormPengguna;
